import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GameBaseApi,
  HandballGameApi,
  HandballGameStatistic,
  HandballGameTeamStatistic
} from '@mtgame/core';
import {
  GameStatisticService,
  STORE_TEAM_STATISTIC_KEY,
  STORE_USER_STATISTIC_KEY
} from '@core/services/game-statistic.service';
import { GameRootService } from '@core/services/game-root.service';

@Injectable()
export class HandballGameStatisticService extends GameStatisticService {
  get teamStatistic$(): Observable<HandballGameTeamStatistic> {
    return this.store.get(STORE_TEAM_STATISTIC_KEY);
  }

  get userStatistic$(): Observable<HandballGameStatistic[]> {
    return this.store.get(STORE_USER_STATISTIC_KEY);
  }

  constructor(
    protected gameRootService: GameRootService,
    private handballGameApi: HandballGameApi,
    protected gameBaseApi: GameBaseApi,
  ) {
    super(gameRootService, gameBaseApi);
  }

  async getTeamStatistic(): Promise<HandballGameTeamStatistic> {
    const teamStatistic = await this.handballGameApi.getTeamStatistic(this.gameId);
    this.store.save(STORE_TEAM_STATISTIC_KEY, teamStatistic);
    return teamStatistic;
  }

  async getUserStatistic(): Promise<HandballGameStatistic[]> {
    const userStatistic = await this.handballGameApi.getUserStatistic(this.gameId);
    this.store.save(STORE_USER_STATISTIC_KEY, userStatistic);
    return userStatistic;
  }
}
